// extracted by mini-css-extract-plugin
module.exports = {"large":"e2036","title":"_6a7be","medium":"a4e86","small":"b57fb","wrapper":"_43c48"};